import React from 'react';

import { Flex, HStack, Text, Input, Button } from '@chakra-ui/react';

import { useColors } from './colors';

const OrdersPagination = ({
  currentPage,
  totalPages,
  pageInput,
  setPageInput,
  onPageChange,
  hasOrders,
}) => {
  const { inputColor } = useColors();

  const getPaginationRange = () => {
    const maxButtons = 5;
    const halfRange = Math.floor(maxButtons / 2);
    let startPage = Math.max(currentPage - halfRange, 1);
    let endPage = Math.min(startPage + maxButtons - 1, totalPages);
    if (endPage - startPage + 1 < maxButtons) {
      startPage = Math.max(endPage - maxButtons + 1, 1);
    }
    const pages = [];
    for (let i = startPage; i <= endPage; i++) pages.push(i);
    return pages;
  };

  if (!hasOrders || totalPages <= 1) return null;

  const range = getPaginationRange();

  return (
    <Flex justify="space-between" align="center" flexWrap="wrap" gap={3}>
      <HStack spacing={2}>
        <Text fontSize="sm">Page</Text>
        <Input
          size="sm"
          type="number"
          value={pageInput}
          onChange={(e) => setPageInput(Number(e.target.value))}
          width="60px"
          color={inputColor}
        />
        <Text fontSize="sm">of {totalPages}</Text>
        <Button
          size="sm"
          variant="outline"
          onClick={() => {
            const page = parseInt(pageInput, 10);
            if (page >= 1 && page <= totalPages) onPageChange(page);
          }}
        >
          Go
        </Button>
      </HStack>
      <HStack spacing={2} flexWrap="wrap">
        <Button
          size="sm"
          variant="outline"
          isDisabled={currentPage <= 1}
          onClick={() => onPageChange(currentPage - 1)}
        >
          Previous
        </Button>
        {range.map((page) => (
          <Button
            key={page}
            size="sm"
            variant={page === currentPage ? 'solid' : 'outline'}
            colorScheme={page === currentPage ? 'blue' : 'gray'}
            onClick={() => onPageChange(page)}
          >
            {page}
          </Button>
        ))}
        {range[range.length - 1] < totalPages && (
          <>
            <Text>…</Text>
            <Button size="sm" variant="outline" onClick={() => onPageChange(totalPages)}>
              {totalPages}
            </Button>
          </>
        )}
        <Button
          size="sm"
          variant="outline"
          isDisabled={currentPage >= totalPages}
          onClick={() => onPageChange(currentPage + 1)}
        >
          Next
        </Button>
      </HStack>
    </Flex>
  );
};

export default OrdersPagination;
